"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var hero_1 = require("../../utils/shopify-graphql/hero");
var path_1 = require("../../utils/shopify/path");
var media_query_1 = require("../../hooks/media-query");
var HeroSingle_1 = require("./HeroSingle");
var Hero = function () {
    var _a = (0, hooks_1.useState)(null), data = _a[0], setData = _a[1];
    var isDesktop = (0, media_query_1.useMediaQuery)('(min-width: 1025px)');
    var device = isDesktop ? 'desktop' : 'mobile';
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, hero_1.getHeroData)(handle, pathType)
            .then(function (d) { return setData(d); })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!data && location.pathname == '/') {
        setData({
            ctaColor: {
                text: 'white',
                hover: 'gogo-orange',
                backgroundStart: 'gogo-orange',
                backgroundEnd: 'gogo-pale-orange',
            },
            version: 'homepage',
            color: 'charcoal',
            logo: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/URO_Logo.svg?v=1706640030',
            contents: [
                {
                    header: "[bold]((Women's Health,))[br][italic]((Backed By Science))",
                    mobile: {
                        background: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-hero-mobile_0f2fc6f0-d2d9-4f37-bf87-c2f13c79595f.jpg?v=1727294571',
                    },
                    desktop: {
                        background: 'https://cdn.shopify.com/s/files/1/0588/9340/2261/files/homepage-hero-desktop_2.jpg?v=1727384725',
                    },
                },
            ],
        });
    }
    if (!data) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)(HeroSingle_1.default, { data: data, device: device })));
};
exports.default = Hero;
